module.exports = __webpack_public_path__ + "img/bg38.48a04691.png";